import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@mui/material/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
  root: {
    margin: theme.spacing(1),
  },
}));

const Goal = ({
  priority,
  title,
  subheader,
  content,
  status,
  goalId,
  onEdit,
  onDelete,
  collapsed,
  ...rest
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(!collapsed);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const priorityLetter = priority !== undefined && priority.length > 0
    ? priority.toUpperCase()[0]
    : '?';
  let color = 'red';
  if (priority === 'medium') {
    color = 'orange';
  }
  if (priority === 'low') {
    color = 'green';
  }
  return (
    <Card
      className={classes.root}
      {...rest}
    >
      <CardHeader
        avatar={
          <Avatar aria-label="priority" style={{ backgroundColor: color }}>
            {priorityLetter}
          </Avatar>
        }
        action={
          <span>
            <IconButton
              aria-label="edit"
              onClick={() => { onEdit(goalId); }}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              aria-label="delete"
              onClick={() => { onDelete(goalId); }}
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </IconButton>
          </span>
        }
        title={title}
        subheader={`${subheader} (${status}%)`}
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>{content}</Typography>
        </CardContent>
      </Collapse>
    </Card>
  );
};

Goal.propTypes = {
  priority: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subheader: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  goalId: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  collapsed: PropTypes.bool,
};

Goal.defaultProps = {
  collapsed: false,
};

export default Goal;
